import React from 'react';
import { motion } from 'framer-motion';
import RupeeSymbol from '../RupeeSymbol';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      text: (
        <>
          The quarterly + eCourse deal was perfect for me. I learned Elite's tools and professional strategies together. Best <RupeeSymbol />11,503 I've spent on trading.
        </>
      ),
      author: "Kavita Rao",
      location: "Quarterly + eCourse Member, Chennai"
    },
    {
      text: "Order Flow showed me institutional buying 20 minutes before NIFTY jumped 250 points. My annual Elite plan paid for itself in that single trade. Everything else is pure profit.",
      author: "Rajesh Kumar",
      location: "Annual Member, Mumbai"
    },
    {
      text: "Started with monthly because I wasn't sure. Upgraded to annual after 3 weeks. Elite isn't optional once you experience it—it's essential.",
      author: "Rohit Khanna",
      location: "Started Monthly → Annual, Mumbai"
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          💬 What Elite Members Say
        </motion.h2>
        
        <div className="testimonial-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="testimonial"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <div className="testimonial-text">
                "{testimonial.text}"
              </div>
              <div className="testimonial-author">{testimonial.author}</div>
              <div className="testimonial-location">{testimonial.location}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

